/*
 * Hack for the footer display as the footer is
 * not 100% of the window height
 *
 * @author BarrelNY
 * @link https://github.com/alvarotrigo/fullPage.js
 *
 */

var Footer = {
	init:function(){

		//What templates should trigger this module?
		var templates = [
			'body.home-page'
		].join();

		if (!$(templates).length) return;

		this.$sections = $('#scroll-container [class^="section-"]');
		this.total = this.$sections.length;
		if (this.total) this.events();
	},

	events:function(){
		$('body')
			.on('fullPage__onLeave',this.offsetContainer.bind(this));

		$(window)
			.on('resize',$.debounce(500,this.adjustOffset.bind(this,false)));
	},

	/*
	 * Determine if we are seeing the last page on the
	 * homepage and if so, adjust the height.
	 *
	 * @param	obj	event object
	 * @param	string	index we're moving away from
	 * @param	string	index we're moving towards
	 * @param	string	the direction we are going
	 * @returns void
	 */
	offsetContainer:function(e,index, nextIndex, direction){
		var c = this.total;

		if (nextIndex == c || index == c){
			this.adjustOffset(direction);
		}
	},

	/*
	 * We determine the difference between the size the footer
	 * and the size of the window and place a top offset
	 * to make sure that footer sit at the bottom of the viewport
	 *
	 * @params	string | boolean	if called by resize event, false is sent
	 * @returns	void
	 */
	adjustOffset:function(direction){
		var
			$container = $('.fullpage-wrapper'),
			existing = !!Number($container[0].style.top.replace('px','')),
			$footer = this.$sections.filter('.section-last');

		//Reset everything
		if ( MUR.isSmall() ){
			$footer.find('.homepage-tile').removeClass('shorter');
			$container.css({top:0});
			return;
		}

		if (!direction && existing) direction = 'down';

		var offset = this.getOffset($footer);

		if (offset <= 0){
			$footer.find('.homepage-tile').addClass('shorter');
			//Get the offset again..
			offset = this.getOffset($footer);
		}

		var top = direction == 'down' ? offset : 0;
		$container.css({top:top});
	},

	/*
	 * Actually determine the difference between the window
	 * height and the footer height
	 *
	 * @params	obj jquery selector
	 * @returns	int the difference
	 */
	getOffset:function($footer){
		var
			Fheight = $footer.find('.inner').height(),
			Wheight = $(window).height();

		return Math.round(Wheight - Fheight);
	}
}

module.exports = Footer
